import { render, staticRenderFns } from "./FlightTravelers.vue?vue&type=template&id=716cdda0&"
import script from "./FlightTravelers.vue?vue&type=script&lang=js&"
export * from "./FlightTravelers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Avijeh.Projects\\Web-Solutions\\IPA.Naga.Web\\Themes\\Eavar.com.V2\\UINew\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('716cdda0')) {
      api.createRecord('716cdda0', component.options)
    } else {
      api.reload('716cdda0', component.options)
    }
    module.hot.accept("./FlightTravelers.vue?vue&type=template&id=716cdda0&", function () {
      api.rerender('716cdda0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Js/Services/Tourism/Components/FlightTravelers.vue"
export default component.exports